import {
  put, all, takeLatest, select,
} from 'redux-saga/effects';

import { delay } from 'redux-saga';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { exception } from 'circe/logger';
import { paySuccess } from 'domain/payment/actions';
import { ROUTES as SHIPMENT_ASSIGN_ROUTES } from 'domain/shipment/assign/constants';
import { requestAddressUpdate } from 'domain/shipment/actions';
import { fetch, fetched, fetchedTrips } from './actions';

function* doFetch(action) {
  const { payload } = action;

  const { id } = payload;

  try {
    const availableQuotes = localStorage.getItem('BATCH_SHIPMENTS');
    const quote = JSON.parse(availableQuotes)[id];

    if (!quote || !quote.shipments) {
      throw new Error('Quote shipments are not available!');
    }

    // const results = quotes.map(quote => ({
    //   ...quote,
    //   shipperId: shipments[0].shipperId,
    //   batches: quote.batches.map(batch => ({
    //     ...batch,
    //     items: batch.items.map(item => ({
    //       ...item,
    //       ...shipments.find(shipment => shipment.shipmentId === item.shipmentId),
    //     })),
    //   })),
    // }));

    const results = quote;

    // yield put(
    //   fetchedTrips(
    //     formatItinerariesRoutes(results.reduce((acc, item) => [...acc, ...item.batches], [])),
    //   ),
    // );

    yield put(fetched(results));
  } catch (error) {
    yield put(
      showNotification(
        I18n.str('fetchBatchResultsFailed', 'Unable to fetch quote results'),
        'error',
      ),
    );
    exception(error);
  }
}

function* afterBatchBookSuccess(context) {
  context.history.push(SHIPMENT_ASSIGN_ROUTES.ROOT);
  yield delay(500);
  try {
    const state = yield select();
    const { shipments } = state.app.batches.sheets.view;
    const invalidAddresses = shipments.filter((row) => row.addressStatus === 'MISSING');
    if (invalidAddresses.length) {
      const msg = I18n.str(
        'weFoundInvalidShipment',
        '{count} Shipments have invalid address, do you want to notify customers via Whatsapp?',
        {
          count: invalidAddresses.length,
        },
      );
      const confirmRespose = confirm(msg);
      if (confirmRespose) {
        for (const shipment of invalidAddresses) {
          const { waybill, receiverPhone } = shipment;
          yield put(requestAddressUpdate(waybill, receiverPhone));
        }
      }
    }
  } catch (e) {}

  yield delay(2500);
  yield put(
    showNotification(
      I18n.str('emailWillBeSent', 'An email will be sent to you with the shipping labels'),
      'success',
    ),
  );
}

export default function* (context) {
  yield all([
    takeLatest(fetch().type, doFetch),
    takeLatest(paySuccess().type, afterBatchBookSuccess, context),
  ]);
}
